import { render } from "./productIcon.vue?vue&type=template&id=64686826"
import script from "./productIcon.vue?vue&type=script&lang=js"
export * from "./productIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__